var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100% !important"}},[_c(_vm.layout,{tag:"component",staticClass:"mainClass"}),_c('router-view'),_c('FooterPage'),_c('Toast',{attrs:{"baseZIndex":1020}}),_c('ConfirmDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }